import React from 'react'
import ForbiddenPageContent from '../components/Forbidden/ForbiddenContent'
const ForbiddenPage = () => {
    return <ForbiddenPageContent />
}

export { ForbiddenPage }